import React from "react";
import BlogTwentySeven from "../component/BlogTwentySeven";

function BlogTwentySevenContainer() {
  return <BlogTwentySeven />;
}
export default BlogTwentySevenContainer;
